import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="logo-text">Seoul Station</div>
            <p>Premium Korean food & lifestyle products, delivered across Pakistan.</p>
          </div>

          <div className="footer-col">
            <h5>Shop</h5>
            <ul>
              <li><Link to="/products">All Products</Link></li>
              <li><Link to="/orders">Track Order</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Seoul Station. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
